import { createApp } from "vue";
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
import App from "./App.vue";
import router from "./router";
import AOS from "aos";
import "aos/dist/aos.css";
import i18n from "./i18n";
import store from "./state/store";
import axios from "axios";

import BootstrapVueNext from "bootstrap-vue-next";
import vClickOutside from "click-outside-vue3";
import VueApexCharts from "vue3-apexcharts";
import { vMaska } from "maska";

import VueFeather from "vue-feather";
import money from 'v-money3'

import "@/assets/scss/config/default/app.scss";
import "leaflet/dist/leaflet.css";
import "@/assets/scss/mermaid.min.css";
import "@/assets/scss/style.css";
import "bootstrap/dist/js/bootstrap.bundle";

// FakeBackend authentication
// import { configureFakeBackend } from './helpers/fake-backend';
// configureFakeBackend();

// Firebase authentication
// import { initFirebaseBackend } from './authUtils';

// const firebaseConfig = {
//     apiKey: process.env.VUE_APP_APIKEY,
//     authDomain: process.env.VUE_APP_AUTHDOMAIN,
//     databaseURL: process.env.VUE_APP_VUE_APP_DATABASEURL,
//     projectId: process.env.VUE_APP_PROJECTId,
//     storageBucket: process.env.VUE_APP_STORAGEBUCKET,
//     messagingSenderId: process.env.VUE_APP_MEASUREMENTID
// };

// initFirebaseBackend(firebaseConfig);

AOS.init({
  easing: "ease-out-back",
  duration: 1000,
});

import moment from 'moment';

const app = createApp(App);

app.directive('no-negative', {
  beforeMount(el) {
    el.addEventListener('input', () => {
      const value = parseFloat(el.value);
      if (value < 0) {
        el.value = 0; // Reset ke 0
        el.dispatchEvent(new Event('input')); // Trigger v-model update
      }
    });
  },
});

app.config.globalProperties.$filters = {
  formatDate(value, format = 'DD MMM YYYY') {
    if (value) {
      return moment(String(value)).format(format);
    }
  },
  formatDateTime(value, format = 'DD MMM YYYY HH:mm') {
    if (value) {
      return moment(String(value)).format(format);
    }
  },
  formatRupiah(value) {
    if (value) {
      return new Intl.NumberFormat('id-ID', { style: 'currency', currency: 'IDR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(value);
    }
  }
};

axios.defaults.headers.common["x-device-id"] = localStorage.getItem("device-id");


app
  .use(store)
  .use(router)
  .use(Toast)
  .use(VueApexCharts)
  .use(money)
  .use(BootstrapVueNext)
  .component(VueFeather.type, VueFeather)
  .directive("maska", vMaska)
  .use(i18n)
  .use(vClickOutside)
  .mount("#app");
